import { z } from "zod"

export type DataUpdatePayload = z.infer<typeof dataUpdatePayloadSchema>
export type StrictDataUpdateV1Payload = z.infer<typeof strictDataUpdateV1PayloadSchema>
export type TripleUpdatePayload = z.infer<typeof tripleUpdatePayloadSchema>

export const tripleUpdatePayloadSchema = z.object({
  graph: z.string().nonempty(),
  subject: z.string().nonempty(),
  predicate: z.string().nonempty(),
  object: z.discriminatedUnion("type", [
    z.object({
      type: z.literal("uri"),
      value: z.string()
    }),
    z.object({
      type: z.literal("literal"),
      value: z.string(),
      dataType: z.string().optional(),
      languageTag: z.string().optional()
    })
  ])
})

export const mutationLogPayloadSchema = z.object({
  graph: z.string(),
  customStatements: z.string(),
})

export const dataUpdatePayloadSchema = z.object({
  updates: z.array(tripleUpdatePayloadSchema),
  delete: z.array(tripleUpdatePayloadSchema),
  logging: z.optional(mutationLogPayloadSchema),
})

export const strictDataUpdateV1PayloadSchema = z.object({
  variant: z.literal('strict-v1'),
  inserts: z.array(tripleUpdatePayloadSchema),
  deletes: z.array(tripleUpdatePayloadSchema),
  logging: z.optional(mutationLogPayloadSchema),
})
